import React from 'react';

import {
  ImageWithBackground,
  type ImageWithBackgroundVariant,
} from '@app/shared/ui/molecules/Common/index';
import { cn } from '@app/shared/utils/common';
import { FeaturedImagePosition } from '@app/shared/types/modal';

interface FeaturedModalImageContainerProps {
  imgPosition?: FeaturedImagePosition;
  backgroundVariant?: ImageWithBackgroundVariant;
  children: React.ReactNode;
}

export function FeaturedModalImageContainer({
  imgPosition = FeaturedImagePosition.ABSOLUTE,
  backgroundVariant,
  children,
}: FeaturedModalImageContainerProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center',
        imgPosition === 'absolute'
          ? 'absolute -top-[85px] left-1/2 h-40 w-40 -translate-x-1/2'
          : 'mx-auto'
      )}
    >
      {backgroundVariant ? (
        <ImageWithBackground variant={backgroundVariant}>{children}</ImageWithBackground>
      ) : (
        children
      )}
    </div>
  );
}
